import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Force all gsap animations to use gpu
gsap.config({
    force3D: true,
});

gsap.registerPlugin(ScrollTrigger);

export const scrollTrigger = (target, trigger, options) => {
    gsap.to(target, {
        scrollTrigger: {
            trigger: trigger,
            start: "top bottom", // when the top of the trigger hits the top of the viewport
            scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
        },
        ...options,
    });
};
